export default "__VITE_ASSET__Cl6LK_JR__"